import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, Grid, IconButton } from '@mui/material';
import { FieldArray } from 'formik';
import React from 'react';
import { IFlowConditions, ITaskCondition } from 'types/flows';
import { FormikTextField } from '../../../Inputs';
import AtomicCondition from './AtomicCondition';
import { newAtomicCondition } from './helpers';
import { ConditionChangeCallback } from './types';

interface ITaskConditionItemProps {
	formikName: string;
	conditions: IFlowConditions;
	taskCondition: ITaskCondition;
	onConditionChange?: ConditionChangeCallback;
}

const TaskConditionItem = ({
	formikName,
	taskCondition,
	conditions,
	onConditionChange
}: ITaskConditionItemProps) => {
	const { atomicConditions } = taskCondition;

	return (
		<Box>
			<Grid item container alignItems="center" spacing={2} xs={12}>
				<Grid item xs={11} pb={2} ml={0}>
					<FormikTextField
						name={`${formikName}.name`}
						required
						fullWidth
						autoComplete="on"
						size="small"
						label={intl.tr(
							'add.condition.task.dialog.conditions.condition.name'
						)}
					/>
				</Grid>
			</Grid>
			<Box>
				{/* Temporarely removed: https://github.com/descope/etc/issues/660 */}
				{/* <FormikToggleButtonOptions
					name={`${formikName}.logicalOr`}
					options={[
						{
							value: false,
							label: intl.tr(
								'add.condition.task.dialog.conditions.condition.logical.or.false'
							)
						},
						{
							value: true,
							label: intl.tr(
								'add.condition.task.dialog.conditions.condition.logical.or.true'
							)
						}
					]}
				/> */}
				<FieldArray
					name={`${formikName}.atomicConditions`}
					render={(arrayHelpers) => (
						<Grid container>
							{atomicConditions.map((ac, i) => (
								/* eslint react/no-array-index-key: 0 */
								<React.Fragment key={`${i}`}>
									<Grid item xs={11} data-testid="atomic-condition">
										<AtomicCondition
											conditions={conditions}
											atomicCondition={ac}
											formikName={`${formikName}.atomicConditions.${i}`}
											onConditionChange={onConditionChange}
										/>
									</Grid>
									<Grid item xs={0.5} pt={2.2}>
										<IconButton
											onClick={() =>
												arrayHelpers.insert(i + 1, newAtomicCondition())
											}
											aria-label={intl.tr('button.add')}
											data-testid="add-atomic-condition-input"
											size="small"
											disableRipple
										>
											<AddIcon color="primary" />
										</IconButton>
									</Grid>
									<Grid item xs={0.5} pt={2.2}>
										{atomicConditions.length > 1 && (
											<IconButton
												size="small"
												onClick={() => arrayHelpers.remove(i)}
												aria-label={intl.tr('button.delete')}
												data-testid="delete-atomic-condition-input"
												disableRipple
											>
												<RemoveIcon color="primary" />
											</IconButton>
										)}
									</Grid>
								</React.Fragment>
							))}
						</Grid>
					)}
				/>
			</Box>
		</Box>
	);
};

TaskConditionItem.defaultProps = {
	onConditionChange: () => {}
};

export default TaskConditionItem;
